export default __webpack_public_path__ + "static/media/reloadFaq1.bc4e405b.png";